import React, { useState, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { FiMenu, FiX } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Navbar = () => {
  const { lang, toggleLanguage, t } = useLanguage();
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: t.nav.about, href: '#about' },
    { name: t.nav.services, href: '#services' },
    { name: t.nav.customers, href: '#customers' },
    { name: t.nav.projects, href: '#projects' },
    { name: t.nav.experience, href: '#experience' },
    { name: t.nav.faq, href: '#faq' },
    { name: t.nav.shop, href: 'https://shop.konsulentbixen.dk/', external: true },
  ];

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-brand-dark/90 backdrop-blur-md border-b border-brand-border py-4' : 'bg-transparent py-6'}`}>
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        <a href="#" className="text-xl font-bold text-brand-textHeading tracking-tight">
          Konsulentbixen<span className="text-brand-accent">.</span>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-6 lg:gap-8">
          {navLinks.map((link) => (
            <a 
              key={link.name} 
              href={link.href} 
              target={link.external ? "_blank" : undefined}
              rel={link.external ? "noopener noreferrer" : undefined}
              className="text-sm font-medium text-brand-text hover:text-white transition-colors"
            >
              {link.name}
            </a>
          ))}
          <a href="#contact" className="text-sm font-medium text-brand-accent hover:text-brand-accentHover transition-colors">
            {t.nav.contact}
          </a>
          <div className="w-px h-4 bg-brand-border mx-1"></div>
          <div className="flex items-center gap-2 text-sm font-medium">
            <button 
              onClick={() => toggleLanguage('da')} 
              className={`transition-colors ${lang === 'da' ? 'text-white' : 'text-brand-textMuted hover:text-brand-text'}`}
            >
              DA
            </button>
            <span className="text-brand-border">|</span>
            <button 
              onClick={() => toggleLanguage('en')} 
              className={`transition-colors ${lang === 'en' ? 'text-white' : 'text-brand-textMuted hover:text-brand-text'}`}
            >
              EN
            </button>
          </div>
        </nav>

        {/* Mobile Toggle */}
        <button 
          className="md:hidden text-brand-text hover:text-white"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          <SafeIcon icon={mobileMenuOpen ? FiX : FiMenu} className="w-6 h-6" />
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden absolute top-full left-0 right-0 bg-brand-darker border-b border-brand-border p-6 flex flex-col gap-6 shadow-2xl">
          {navLinks.map((link) => (
            <a 
              key={link.name} 
              href={link.href} 
              target={link.external ? "_blank" : undefined}
              rel={link.external ? "noopener noreferrer" : undefined}
              className="text-base font-medium text-brand-text hover:text-white"
              onClick={() => setMobileMenuOpen(false)}
            >
              {link.name}
            </a>
          ))}
          <a href="#contact" className="text-base font-medium text-brand-accent" onClick={() => setMobileMenuOpen(false)}>
            {t.nav.contact}
          </a>
          <div className="flex items-center gap-4 pt-4 border-t border-brand-border mt-2">
            <button 
              onClick={() => { toggleLanguage('da'); setMobileMenuOpen(false); }} 
              className={`text-sm font-medium ${lang === 'da' ? 'text-white' : 'text-brand-textMuted'}`}
            >
              Dansk
            </button>
            <button 
              onClick={() => { toggleLanguage('en'); setMobileMenuOpen(false); }} 
              className={`text-sm font-medium ${lang === 'en' ? 'text-white' : 'text-brand-textMuted'}`}
            >
              English
            </button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;